import { render, staticRenderFns } from "./GeneralInfo.vue?vue&type=template&id=257af4b7&scoped=true&"
import script from "./GeneralInfo.vue?vue&type=script&lang=ts&"
export * from "./GeneralInfo.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralInfo.vue?vue&type=style&index=0&id=257af4b7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257af4b7",
  null
  
)

export default component.exports